var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ProgressProvider } from 'hx-progress';
var defaultPhases = [
    {
        name: 'setup',
        stepCount: 5,
    },
    {
        name: 'test',
        stepCount: 23,
    },
    {
        name: 'result',
        stepCount: 5,
    },
];
export var withProgress = function (phases) {
    if (phases === void 0) { phases = defaultPhases; }
    return function (Story) {
        return (_jsx(ProgressProvider, __assign({ phases: phases }, { children: _jsx(Story, {}) })));
    };
};
